// extracted by mini-css-extract-plugin
export var iconDefaultColors = "iconPlayAlt-module--iconDefaultColors--0dadc";